<template>
  <div id="dod">
    <table-view 
      :end-point="endPoint"
      :column-defs="columnDefs"
      :filters="filters"
      >
    </table-view>
  </div>
</template>

<script>

import tableView from '../../components/tableView';
export default {
  components: {   
    tableView
  },
  data() {
    
    let data = {
      params:{},
      endPoint:'dod',
      filters: {}
    }
    data.columnDefs= [
        {
          headerName: 'type',
          field: 'type',
          width: 125,
          filter: true,
        },
        {
          headerName: 'dc_id',
          field: 'dc_id',
          filter: true,
          width: 125,
          type: ['dateColumn', 'nonEditableColumn'],
        },
        {
          headerName: 'deposit_date',
          field: 'deposit_date',
          filter: true,
          width: 175,
        },
        {
          headerName: 'broker',
          field: 'broker',
          filter: true,
          width: 125,
        },
        {
          headerName: 'cl_id',
          field: 'cl_id',
          filter: true,
          width: 125,
        },
        {
          headerName: 'email',
          field: 'email',
          filter: true,
          width: 250,
        },
        {
          headerName: 'client_name',
          field: 'client_name',
          filter: true,
          width: 150,
        },
        {
          headerName: 'amount',
          field: 'amount',
          filter: true,
          width: 125,
        },
        {
          headerName: 'account_number',
          field: 'account_number',
          filter: true,
          width: 125,
        },
        {
          headerName: 'st_name',
          field: 'st_name',
          filter: true,
          width: 125,
        },
        {
          headerName: 'wall',
          field: 'wall',
          filter: "agNumberColumnFilter",
          width: 125,
        }        
      ]
    return data;
  },
  computed: {
  },
  mounted() {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
  }
}

</script>